import { UserListAccessLevel, OrganizationUserRole } from "db/enums"
import { isSchoolAdminRole } from "app/users/utils/schoolAdminRoles"

export default function getListTypeCanAdd(
  accessLevel: UserListAccessLevel,
  role?: OrganizationUserRole
) {
  switch (accessLevel) {
    case "PERSONAL":
      return true
    case "GROUP":
    case "KIDS":
      if (role) {
        return true
      }
      return false
    case "GLOBAL":
      return false
    case "SCHOOL":
      return isSchoolAdminRole(role)
  }
}
